
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33769',
  depVersions: {
  "documents-public-ui": "static-1.33769",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33774",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1830",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5301",
  "hs-test-utils": "static-1.7693",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11134",
  "I18n": "static-7.1544",
  "jasmine-immutable": "static-1.2727",
  "jasmine-runner": "static-1.6165",
  "lodash": "static-1.3",
  "quartz": "static-1.6594",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16343",
  "reporting-data": "static-1.66146",
  "reporting-testing-lib": "static-1.8079",
  "reporting-visualizations": "static-1.58222",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4455",
  "webpack-env": "static-1.54",
  "atom": "static-1.4782",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2176",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.703",
  "customer-data-filters-ui": "static-1.38565",
  "customer-data-objects": "static-1.7323",
  "customer-data-property-utils": "static-1.7780",
  "data-fetching-client": "static-1.9385",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4245",
  "flux-actions": "static-1.298",
  "FormsCommonComponents": "static-1.85039",
  "FormUrlGenerator": "static-2.4441",
  "foundations-components": "static-1.7334",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11442",
  "icons": "static-2.614",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6854",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3570",
  "property-translator": "static-1.5124",
  "quartz-config": "static-1.372",
  "quartz-core": "static-1.5813",
  "quick-fetch": "static-1.3647",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5094",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7871",
  "reference-resolvers-lite": "static-1.7800",
  "report-customization-components": "static-1.12254",
  "reporting-enablement": "static-1.21792",
  "reporting-reports": "static-1.65824",
  "reporting-snowflake": "static-1.54764",
  "reporting-ui-components": "static-2.63418",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4317",
  "sales-content-partitioning": "static-1.8643",
  "SalesContentIndexUI": "static-3.8757",
  "sanitize": "static-1.4185",
  "sanitize-text": "static-1.7850",
  "self-service-api": "static-1.9936",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1460",
  "signup-constants": "static-1.18225",
  "signup-ui-lego-core": "static-1.20235",
  "signup-ui-url-generator": "static-2.7742",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4483",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10706",
  "ui-addon-i18n": "static-1.10838",
  "ui-addon-react-router-dom": "static-1.9257",
  "ui-addon-upgrades": "static-9.17431",
  "ui-asset-management-lib": "static-1.10573",
  "ui-images": "static-2.1064",
  "UIComponents": "static-3.8081",
  "usage-tracker": "static-1.7046",
  "usage-tracker-container": "static-1.7036",
  "usage-tracker-core": "static-1.6896",
  "usage-tracker-public": "static-1.6857",
  "viral-links-lib": "static-1.6730",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3147",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2871",
  "quartz-webpack": "static-1.2818",
  "ai-components-ui-library": "static-1.8120",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4542",
  "foundations-theming": "static-1.4114",
  "quartz-auth": "static-1.269",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4732",
  "foundations-theming-base": "static-1.3099",
  "HeadJS": "static-2.692",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2804",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4041",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7634",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3378",
  "persist-promise": "static-1.3397",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9137",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9238",
  "hubspotter-http": "static-1.4396",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6961",
  "crm-message-bus": "static-1.42135",
  "customer-data-filters-ui-msw-helpers": "static-1.20999",
  "customer-data-objects-ui-components": "static-1.12711",
  "customer-data-reference-ui-components": "static-1.12848",
  "customer-data-ui-utilities": "static-1.9536",
  "framework-builder-read-service-client": "static-1.3765",
  "framework-data-schema-quick-fetch": "static-1.6485",
  "framework-data-schema-resolvers": "static-1.6580",
  "inbound-db-properties-service-client": "static-1.3597",
  "multi-account-reference-resolvers": "static-1.677",
  "onboarding-tours": "static-1.16148",
  "reporting-datasets-permissions-lib": "static-1.12751",
  "ui-addon-teams": "static-1.21102",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67357",
  "customer-data-properties": "static-1.50519",
  "forms-ai-lib": "static-1.3858",
  "forms-utils-lib": "static-1.11999",
  "foundations-components-test-utils": "static-1.4817",
  "react-dnd-compat": "static-1.4334",
  "react-tinymce": "static-1.54386",
  "tinymce-config": "static-2.53512",
  "ui-gdpr-components": "static-1.10055",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3603",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.995",
  "ui-fonts": "static-1.396",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.773",
  "mobile-manifest-mixins": "static-1.465",
  "quartz-head": "static-1.259",
  "quartz-i18n": "static-1.269",
  "quartz-test": "static-1.269",
  "batch-promise": "static-1.1240",
  "external-options-client-types": "static-1.3901",
  "react-colorpicker": "static-2.9923",
  "copilot-toolkit": "static-1.10313",
  "data-quality-ui-library": "static-1.12121",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40458",
  "reporting-insights-lib": "static-1.913",
  "reporting-plugins": "static-1.9871",
  "ui-addon-draggable-compat": "static-2.3964",
  "ui-addon-opt": "static-4.8099",
  "ui-shepherd-react": "static-3.9854",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24482",
  "hubspot-apollo-client": "static-1.4590",
  "sales-templates-service-types-lib": "static-1.3911",
  "ui-business-units-lib": "static-1.8731",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5343",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3822",
  "upgrade-management-service-types": "static-1.4218",
  "timezone-utils": "static-2.4954",
  "bender-build-tools": "static-1.2823",
  "chatspot-core": "static-1.20007",
  "chirp-fetch": "static-1.1592",
  "bend-plugin-foundations-theming": "static-1.2597",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9236",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3541",
  "crm-pipelines-api-client-types": "static-1.3883",
  "multi-currency-client-types": "static-1.3439",
  "getting-started-shared-tasks": "static-1.17628",
  "growth-data-modal": "static-1.5042",
  "growth-onboarding-confetti": "static-1.2761",
  "growth-onboarding-next-action-utils": "static-1.1205",
  "navigation-components": "static-1.17016",
  "onboarding-tours-client": "static-1.4362",
  "onboarding-tours-utils": "static-1.214",
  "ui-shepherd-tracker": "static-1.7235",
  "ui-universal-auth": "static-1.8575",
  "user-context": "static-1.4804",
  "cms-field-types": "static-1.4518",
  "content-icons-ui": "static-1.2122",
  "integrations-lib": "static-1.15128",
  "calling-global-api": "static-1.63372",
  "calling-internal-common": "static-1.30999",
  "calling-lifecycle-internal": "static-1.64754",
  "calling-lifecycle-messages": "static-1.57048",
  "commerce-products-lib": "static-1.8582",
  "crm-links": "static-1.5962",
  "file-manager-components": "static-1.22641",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.365",
  "inbounddb-objects-service-types": "static-1.3968",
  "meetings-icalendar-utils-lib": "static-1.343",
  "object-builder-ui-client": "static-1.47688",
  "pipeline-validation-client-types": "static-1.3705",
  "property-value-citations": "static-1.1133",
  "pulse": "static-1.204",
  "smart-property-lib": "static-1.5578",
  "tiered-pricing": "static-1.681",
  "ui-addon-iframeable": "static-1.8729",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19310",
  "tinymce-themes": "static-1.55482",
  "data-token-picker": "static-1.15906",
  "hub-http-contrib": "static-1.2756",
  "interframe": "static-3.4503",
  "tinymce-data": "static-1.39597",
  "tinymce-plugins": "static-1.56626",
  "ui-addon-sales-email": "static-1.4924",
  "magpie-lib": "static-1.5286",
  "magpie-types": "static-1.4746",
  "simple-logging-lib": "static-1.2761",
  "content-assistance-lib": "static-1.7318",
  "dashboard-lib": "static-1.80268",
  "ExportDialog": "static-6.10098",
  "hubspot-prosemirror": "static-1.17373",
  "hubspot-prosemirror-plugins": "static-1.17365",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8399",
  "campaign-roi-lib": "static-1.8013",
  "feedback-loader": "static-1.28696",
  "commerce-analytics-service-client": "static-1.3398",
  "onboarding-scopes": "static-1.6153",
  "apollo-link-hub-http": "static-2.4359",
  "hubspot-apollo-cache": "static-1.49",
  "growth-monetization-service-types": "static-1.4234",
  "nav-client-types": "static-1.2043",
  "purchase-motions-api": "static-1.5346",
  "trials-service-types": "static-1.3635",
  "chatspot-client-types": "static-1.10363",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.436",
  "getting-started-shared-tasks-store": "static-1.16746",
  "cohere-reconnect-lib": "static-1.77",
  "gemini-reconnect-lib": "static-1.36",
  "integrations-error-boundary-lib": "static-1.12543",
  "integrations-tracking-lib": "static-1.5294",
  "native-integrations-shared-strings": "static-1.7498",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10083",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31005",
  "shared-worker-versioning": "static-1.10727",
  "calling-usage-tracker": "static-1.6249",
  "calling-orchestration-shared-library": "static-1.34536",
  "customer-data-tracking": "static-1.6572",
  "products-iframe-lib": "static-1.7102",
  "products-ui-components-shared-msw-handlers": "static-1.9620",
  "location-customization-utils-lib": "static-1.8276",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3866",
  "video-components-external": "static-1.10292",
  "video-data-lib": "static-1.33950",
  "directed-graph": "static-1.648",
  "event-emitter": "static-1.635",
  "breeze-intelligence-kit": "static-1.5187",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9321",
  "fsm": "static-1.3441",
  "policy-lib": "static-1.6512",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9384",
  "navigation-messaging": "static-1.6343",
  "FileManagerLib": "static-1.38281",
  "NamespacedHubStyle": "static-2.8817",
  "FileManagerCore": "static-1.38140",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11879",
  "layout-dnd-utils": "static-1.10854",
  "react-codemirror": "static-1.10315",
  "ui-addon-emoji-picker": "static-1.9600",
  "ui-brand-identity-lib": "static-1.13461",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27702",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8276",
  "payment-link-components": "static-1.22682",
  "EmailSignatureEditor": "static-1.23769",
  "eligibility-engine-service-types": "static-1.2916",
  "universal-page-editor-lib": "static-1.2707",
  "calling-orchestration-schema": "static-1.34761",
  "sales-views-client-types": "static-1.4002",
  "crm-record-cards-service-types": "static-1.3370",
  "content-media-composition-data-lib": "static-1.11094",
  "content-media-compositions": "static-2.15101",
  "media-bridge-lib": "static-1.18426",
  "trellis-story-utils": "static-1.4233",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5482",
  "FileManagerImages": "static-1.35792",
  "video-components": "static-1.12295",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4245",
  "video-embed": "static-1.34784",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67432",
  "layout-data-lib": "static-1.9179",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6296",
  "commerce-tours-lib": "static-1.5575",
  "growth-onboarding-reliability": "static-1.4798",
  "sales-checkout-service-client": "static-1.3410",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21148",
  "sales-email-signature-service-client": "static-1.3551",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21128",
  "outpost": "static-1.3922",
  "advanced-menus-core": "static-1.14668",
  "advanced-menus-lib": "static-1.11659",
  "ui-memberships-settings-lib": "static-1.33189",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14667",
  "simple-menus-lib": "static-1.16184"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33769",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33774",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1830",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5301",
  "hs-test-utils": "/hs-test-utils/static-1.7693",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11134",
  "I18n": "/I18n/static-7.1544",
  "jasmine-immutable": "/jasmine-immutable/static-1.2727",
  "jasmine-runner": "/jasmine-runner/static-1.6165",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6594",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16343",
  "reporting-data": "/reporting-data/static-1.66146",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8079",
  "reporting-visualizations": "/reporting-visualizations/static-1.58222",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4455",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4782",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2176",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.703",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38565",
  "customer-data-objects": "/customer-data-objects/static-1.7323",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7780",
  "data-fetching-client": "/data-fetching-client/static-1.9385",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4245",
  "flux-actions": "/flux-actions/static-1.298",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85039",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4441",
  "foundations-components": "/foundations-components/static-1.7334",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11442",
  "icons": "/icons/static-2.614",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6854",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3570",
  "property-translator": "/property-translator/static-1.5124",
  "quartz-config": "/quartz-config/static-1.372",
  "quartz-core": "/quartz-core/static-1.5813",
  "quick-fetch": "/quick-fetch/static-1.3647",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5094",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7871",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7800",
  "report-customization-components": "/report-customization-components/static-1.12254",
  "reporting-enablement": "/reporting-enablement/static-1.21792",
  "reporting-reports": "/reporting-reports/static-1.65824",
  "reporting-snowflake": "/reporting-snowflake/static-1.54764",
  "reporting-ui-components": "/reporting-ui-components/static-2.63418",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4317",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8643",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8757",
  "sanitize": "/sanitize/static-1.4185",
  "sanitize-text": "/sanitize-text/static-1.7850",
  "self-service-api": "/self-service-api/static-1.9936",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1460",
  "signup-constants": "/signup-constants/static-1.18225",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20235",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7742",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4483",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10706",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10838",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9257",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17431",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10573",
  "ui-images": "/ui-images/static-2.1064",
  "UIComponents": "/UIComponents/static-3.8081",
  "usage-tracker": "/usage-tracker/static-1.7046",
  "usage-tracker-container": "/usage-tracker-container/static-1.7036",
  "usage-tracker-core": "/usage-tracker-core/static-1.6896",
  "usage-tracker-public": "/usage-tracker-public/static-1.6857",
  "viral-links-lib": "/viral-links-lib/static-1.6730",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3147",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2871",
  "quartz-webpack": "/quartz-webpack/static-1.2818",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8120",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4542",
  "foundations-theming": "/foundations-theming/static-1.4114",
  "quartz-auth": "/quartz-auth/static-1.269",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4732",
  "foundations-theming-base": "/foundations-theming-base/static-1.3099",
  "HeadJS": "/HeadJS/static-2.692",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2804",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4041",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7634",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3378",
  "persist-promise": "/persist-promise/static-1.3397",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9137",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9238",
  "hubspotter-http": "/hubspotter-http/static-1.4396",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6961",
  "crm-message-bus": "/crm-message-bus/static-1.42135",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20999",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12711",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12848",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9536",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3765",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6485",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6580",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3597",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.677",
  "onboarding-tours": "/onboarding-tours/static-1.16148",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12751",
  "ui-addon-teams": "/ui-addon-teams/static-1.21102",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67357",
  "customer-data-properties": "/customer-data-properties/static-1.50519",
  "forms-ai-lib": "/forms-ai-lib/static-1.3858",
  "forms-utils-lib": "/forms-utils-lib/static-1.11999",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4817",
  "react-dnd-compat": "/react-dnd-compat/static-1.4334",
  "react-tinymce": "/react-tinymce/static-1.54386",
  "tinymce-config": "/tinymce-config/static-2.53512",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10055",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3603",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.995",
  "ui-fonts": "/ui-fonts/static-1.396",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.773",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.465",
  "quartz-head": "/quartz-head/static-1.259",
  "quartz-i18n": "/quartz-i18n/static-1.269",
  "quartz-test": "/quartz-test/static-1.269",
  "batch-promise": "/batch-promise/static-1.1240",
  "external-options-client-types": "/external-options-client-types/static-1.3901",
  "react-colorpicker": "/react-colorpicker/static-2.9923",
  "copilot-toolkit": "/copilot-toolkit/static-1.10313",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12121",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40458",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.913",
  "reporting-plugins": "/reporting-plugins/static-1.9871",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3964",
  "ui-addon-opt": "/ui-addon-opt/static-4.8099",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9854",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24482",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4590",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3911",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8731",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5343",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3822",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4218",
  "timezone-utils": "/timezone-utils/static-2.4954",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "chatspot-core": "/chatspot-core/static-1.20007",
  "chirp-fetch": "/chirp-fetch/static-1.1592",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2597",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9236",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3541",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3883",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3439",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17628",
  "growth-data-modal": "/growth-data-modal/static-1.5042",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2761",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1205",
  "navigation-components": "/navigation-components/static-1.17016",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4362",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.214",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7235",
  "ui-universal-auth": "/ui-universal-auth/static-1.8575",
  "user-context": "/user-context/static-1.4804",
  "cms-field-types": "/cms-field-types/static-1.4518",
  "content-icons-ui": "/content-icons-ui/static-1.2122",
  "integrations-lib": "/integrations-lib/static-1.15128",
  "calling-global-api": "/calling-global-api/static-1.63372",
  "calling-internal-common": "/calling-internal-common/static-1.30999",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64754",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57048",
  "commerce-products-lib": "/commerce-products-lib/static-1.8582",
  "crm-links": "/crm-links/static-1.5962",
  "file-manager-components": "/file-manager-components/static-1.22641",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.365",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3968",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.343",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47688",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3705",
  "property-value-citations": "/property-value-citations/static-1.1133",
  "pulse": "/pulse/static-1.204",
  "smart-property-lib": "/smart-property-lib/static-1.5578",
  "tiered-pricing": "/tiered-pricing/static-1.681",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8729",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19310",
  "tinymce-themes": "/tinymce-themes/static-1.55482",
  "data-token-picker": "/data-token-picker/static-1.15906",
  "hub-http-contrib": "/hub-http-contrib/static-1.2756",
  "interframe": "/interframe/static-3.4503",
  "tinymce-data": "/tinymce-data/static-1.39597",
  "tinymce-plugins": "/tinymce-plugins/static-1.56626",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4924",
  "magpie-lib": "/magpie-lib/static-1.5286",
  "magpie-types": "/magpie-types/static-1.4746",
  "simple-logging-lib": "/simple-logging-lib/static-1.2761",
  "content-assistance-lib": "/content-assistance-lib/static-1.7318",
  "dashboard-lib": "/dashboard-lib/static-1.80268",
  "ExportDialog": "/ExportDialog/static-6.10098",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17373",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17365",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8399",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8013",
  "feedback-loader": "/feedback-loader/static-1.28696",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3398",
  "onboarding-scopes": "/onboarding-scopes/static-1.6153",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4359",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.49",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4234",
  "nav-client-types": "/nav-client-types/static-1.2043",
  "purchase-motions-api": "/purchase-motions-api/static-1.5346",
  "trials-service-types": "/trials-service-types/static-1.3635",
  "chatspot-client-types": "/chatspot-client-types/static-1.10363",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.436",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16746",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.77",
  "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.36",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12543",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5294",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7498",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10083",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31005",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10727",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6249",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34536",
  "customer-data-tracking": "/customer-data-tracking/static-1.6572",
  "products-iframe-lib": "/products-iframe-lib/static-1.7102",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9620",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8276",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3866",
  "video-components-external": "/video-components-external/static-1.10292",
  "video-data-lib": "/video-data-lib/static-1.33950",
  "directed-graph": "/directed-graph/static-1.648",
  "event-emitter": "/event-emitter/static-1.635",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5187",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9321",
  "fsm": "/fsm/static-1.3441",
  "policy-lib": "/policy-lib/static-1.6512",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9384",
  "navigation-messaging": "/navigation-messaging/static-1.6343",
  "FileManagerLib": "/FileManagerLib/static-1.38281",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8817",
  "FileManagerCore": "/FileManagerCore/static-1.38140",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11879",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10854",
  "react-codemirror": "/react-codemirror/static-1.10315",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9600",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13461",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27702",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8276",
  "payment-link-components": "/payment-link-components/static-1.22682",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23769",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2916",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2707",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34761",
  "sales-views-client-types": "/sales-views-client-types/static-1.4002",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3370",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11094",
  "content-media-compositions": "/content-media-compositions/static-2.15101",
  "media-bridge-lib": "/media-bridge-lib/static-1.18426",
  "trellis-story-utils": "/trellis-story-utils/static-1.4233",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5482",
  "FileManagerImages": "/FileManagerImages/static-1.35792",
  "video-components": "/video-components/static-1.12295",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4245",
  "video-embed": "/video-embed/static-1.34784",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67432",
  "layout-data-lib": "/layout-data-lib/static-1.9179",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6296",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5575",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4798",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3410",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21148",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3551",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "outpost": "/outpost/static-1.3922",
  "advanced-menus-core": "/advanced-menus-core/static-1.14668",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11659",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33189",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14667",
  "simple-menus-lib": "/simple-menus-lib/static-1.16184"
}
};
